export const DEFAULT_SLIDE_WIDTH = 960;
export const DEFAULT_SLIDE_HEIGHT = 540;
export const SLIDE_MARGIN = 20;

export const RETRY_BASE_DELAY_MS = 2000;
export const RETRY_MAX_ATTEMPTS = 3;

export const POLL_INTERVAL_FAST_MS = 500;
export const POLL_INTERVAL_SLOW_MS = 2000;

// Total number of slides the chat-edit `RunOfficeExtractor` payload should
// contain, centered on the currently selected slide. The window shifts
// toward the deck interior when the current slide is near the start or end
// so it always returns up to `min(CHAT_CONTEXT_WINDOW_SIZE, totalSlides)`
// slides. Tuned via the symmetric helper in
// `utils/contextWindow.computeContextSlideWindow` and forwarded to the host
// as `filters.slides.ranges` per the FactSet extractor schema documented in
// `f2_docs/powerpoint/office-extractor/filters/slides.md`.
export const CHAT_CONTEXT_WINDOW_SIZE = 20;

export const STORAGE_KEYS = {
  SELECTED_MODEL: "finster_selected_model",
  NARRATOR_MODE: "finster_narrator_mode",
  NARRATOR_MODEL: "finster_narrator_model",
  TABS_PREFIX: "finster_tabs_",
  REVIEW_RESULTS_PREFIX: "finster_review_results_",
  THEME_VERSION: "finster_theme_version",
  MODEL_PICKER_OVERRIDES: "finster_plugin_model_picker_overrides",
} as const;

export const Z_INDEX = {
  MODAL: 1000,
  DROPDOWN: 100,
  TOOLTIP: 50,
} as const;

export const UI = {
  DEFAULT_FONT_SIZE: 14,
  DEFAULT_LEFT: 50,
  DEFAULT_TOP: 80,
  MAX_RETRIES: 3,
} as const;
